export const SIGNIN_PATH = '/signin'

export const OAUTH_CALLBACK_PATH = '/oauth-callback'

export const ACCESS_DENIED_PATH = '/403'

export const NOT_FOUND_PATH = '/404'

export const NO_PERMISSION_PATH = '/no-permission'

export const ERROR_PATH = '/error'

export const WHITE_LIST_PATHS = [ACCESS_DENIED_PATH, NOT_FOUND_PATH, NO_PERMISSION_PATH, ERROR_PATH]
